import * as React from "react";

import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { useSelector } from "../../../../store";
import { useLocation, useNavigate } from "react-router-dom";

export default function WebDeclaration({
    onChangeWebStyleLayout = () => {}
}) {
    const location = useLocation();
    const navigate = useNavigate();
    const [confirmDeclaration, setConfirmDeclaration] = React.useState(false);
    const learner = useSelector((state) => state.learner?.details || {});
    const publicUrl = process.env.PUBLIC_URL;
    const fullName = `${learner?.name?.first || ""} ${
		learner?.name?.last || ""
	}`.toUpperCase();

    const handleConfirmDeclaration = async () => {
        navigate(`${publicUrl}/instructions${location?.search || ''}`);
   };

   const pStyle = {
    fontSize: "20px",
   }

   React.useEffect(() => {
        // change the layout
        onChangeWebStyleLayout({
            style: {
                backgroundColor: "#148e8e",
                borderBottom: "60px solid #016d7c",
                hideFooter: true,
            }
        });
    }, [onChangeWebStyleLayout]);

	return (
		<React.Fragment>
			<Box
				sx={{
                    flexGrow: "1",
                    padding: "30px",
                    textAlign: "left",
				}}
			>
                <h2>Declaration of Own Work</h2>
                <p style={pStyle}>I, <b>{fullName}</b>, declare that the answers I submit to
					the Online Language, Literacy and Numeracy quiz are my own
					work.</p>
                <p style={pStyle}>I, <b>{fullName}</b>, will not participate in collusion with
					other individuals and I will take proper and reasonable care
					to ensure that my answers are not copied.</p>
                <p style={pStyle}>I, <b>{fullName}</b>, will not impersonate, or allow myself
					to be impersonated by, any person for the purpose of
					completing this assessment.</p>
                
                <h2>Submission</h2>
                <p style={pStyle}>I, <b>{fullName}</b>, accept that the electronic submission
					of my assessment constitutes my agreement to the above
					Declaration of Own Work.</p>
			</Box>
            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                boxSizing: "border-box",
            }}>
                <span></span>
                <FormControlLabel
					sx={{ display: "flex", mt: 2, fontSize: "1rem", marginTop: "0px", }}
					control={
						<Checkbox
							onChange={(e) => {
								setConfirmDeclaration(e.target.checked);
							}}
						/>
					}
					label={
						<Typography variant="h6_bold">
							I have read & confirm the above statements.
						</Typography>
					}
				/>

                <button
                    style={{
                        cursor: "pointer",
                        display: "inline-block",
                        width: "180px",
                        height: "45px",
                        backgroundColor: confirmDeclaration ? "#0e9595" : "grey",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        borderBottom: confirmDeclaration ? "2px solid #0e9595" : "2px solid grey",
                        textDecoration: "none",
                        boxSizing: "border-box",
                        paddingTop: "3px",
                        textAlign: "center",
                        "&:hover": {
                            backgroundColor: "none",
                            cursor: "pointer",
                        },
                    }}
                    onClick={() => handleConfirmDeclaration()}
                    disabled={!confirmDeclaration}
                >
                    <Box component="span" 
                        sx={{
                        fontWeight: "bold",
                        fontSize: "2em",
                        color: "white",
                        textAlign: "center",
                    }}>Next</Box>
                </button>
            </Box>
		</React.Fragment>
	);
}